import "./GlobalLabelFilters.css";

/**
 * Toolbar row of pill toggles (same look as tournament timing filters).
 *
 * @param {string} ariaLabel - `aria-label` on the group
 * @param {{ key: string, label: string, variant: 'all'|'upcoming'|'2d'|'1d'|'ongoing'|'completed' }[]} items
 * @param {string} activeKey - selected `key`
 * @param {() => void} [onAll] - called when the item with `key === "all"` is pressed
 * @param {(key: string) => void} [onToggle] - called for other items (`key` is passed)
 * @param {string} [className]
 * @param {React.CSSProperties} [style]
 */
export default function GlobalLabelFilters({
  ariaLabel,
  items = [],
  activeKey,
  onAll,
  onToggle,
  className = "",
  style
}) {
  return (
    <div className={`gfl-label-filters ${className}`.trim()} style={style}>
      <div
        className="gfl-label-filters__legend"
        role="group"
        aria-label={ariaLabel}
      >
        {items.map((item) => {
          const isActive = activeKey === item.key;
          const pillClass = [
            "gfl-label-filters__pill",
            `gfl-label-filters__pill--${item.variant}`,
            isActive ? "gfl-label-filters__pill--active" : ""
          ]
            .filter(Boolean)
            .join(" ");
          const handleClick = () => {
            if (item.key === "all") onAll?.();
            else onToggle?.(item.key);
          };
          return (
            <button
              key={item.key}
              type="button"
              className={pillClass}
              onClick={handleClick}
            >
              {item.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
